{
  "MACROS": {
    "HEADER": "Makra",
    "DESCRIPTION": "Makro je sada uložených akcí, které pomáhají agentům zákaznické podpory snadno dokončit úkoly. Agenti mohou definovat sadu akcí, jako je označení konverzace štítkem, odeslání přepisu e-mailu, aktualizace vlastního atributu atd., a tyto akce mohou spustit jedním kliknutím.",
    "LEARN_MORE": "Další informace o makrech",
    "HEADER_BTN_TXT": "Vytvořit makro",
    "HEADER_BTN_TXT_SAVE": "Uložit makro",
    "LOADING": "Stahuji marka",
    "ERROR": "Něco se pokazilo, prosím zkuste to znovu.",
    "ORDER_INFO": "Makra se spustí v pořadí, ve kterém přidáte akce. Můžete je přeuspořádat přetažením za úchyt vedle každého uzlu.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Název makra",
          "PLACEHOLDER": "Zadejte název makra",
          "ERROR": "Název je nutný pro vytvoření makra"
        },
        "ACTIONS": {
          "LABEL": "Akce"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro úspěšně přidáno",
        "ERROR_MESSAGE": "Nelze vytvořit makro, zkuste to prosím později"
      }
    },
    "LIST": {
      "404": "Žádná makra nenalezena",
      "TABLE_HEADER": {
        "NAME": "Název",
        "CREATED BY": "Vytořil",
        "LAST_UPDATED_BY": "Poslení úpravy",
        "VISIBILITY": "Viditelnost"
      }
    },
    "DELETE": {
      "TOOLTIP": "Odstranit makro",
      "CONFIRM": {
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, odstranit",
        "NO": "Ne"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro úspěšně odstraněno",
        "ERROR_MESSAGE": "Při odstraňování makra došlo k chybě. Zkuste to prosím později"
      }
    },
    "EDIT": {
      "TOOLTIP": "Upravit makro",
      "API": {
        "SUCCESS_MESSAGE": "Makro úspěšně aktualizováno",
        "ERROR_MESSAGE": "Nelze aktualizovat Makro, zkuste to prosím později"
      }
    },
    "EDITOR": {
      "START_FLOW": "Začátek toku",
      "END_FLOW": "Konec toku",
      "LOADING": "Načítání makra",
      "ADD_BTN_TOOLTIP": "Přidat novou akci",
      "DELETE_BTN_TOOLTIP": "Odstranit akci",
      "VISIBILITY": {
        "LABEL": "Viditelnost makra",
        "GLOBAL": {
          "LABEL": "Veřejné",
          "DESCRIPTION": "Toto makro je veřejně dostupné pro všechny agenty v tomto účtu."
        },
        "PERSONAL": {
          "LABEL": "Soukromé",
          "DESCRIPTION": "Toto makro bude soukromé pro vás a nebude dostupné ostatním."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Spustit",
      "PREVIEW": "Náhled makra",
      "EXECUTED_SUCCESSFULLY": "Makro úspěšně spuštěno"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Klíč atributu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtru je povinný",
      "VALUE_REQUIRED": "Hodnota je povinná",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí být mezi 0 a 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametry akce jsou povinné",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Je vyžadována alespoň jedna podmínka",
      "ATLEAST_ONE_ACTION_REQUIRED": "Je vyžadována alespoň jedna akce"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Přiřadit tým",
      "ASSIGN_AGENT": "Přiřadit agenta",
      "ADD_LABEL": "Přidat štítek",
      "REMOVE_LABEL": "Odebrat štítek",
      "REMOVE_ASSIGNED_TEAM": "Odebrat přiřazený tým",
      "SEND_EMAIL_TRANSCRIPT": "Odeslat e-mailový přepis",
      "MUTE_CONVERSATION": "Ztlumit konverzaci",
      "SNOOZE_CONVERSATION": "Odložit konverzaci",
      "RESOLVE_CONVERSATION": "Vyřešit konverzaci",
      "SEND_ATTACHMENT": "Odeslat přílohu",
      "SEND_MESSAGE": "Odeslat zprávu",
      "CHANGE_PRIORITY": "Změnit prioritu",
      "ADD_PRIVATE_NOTE": "Přidat soukromou poznámku",
      "SEND_WEBHOOK_EVENT": "Odeslat webhook událost"
    },
    "ACTION_VALUES": {
      "SELF": "Já"
    }
  }
}
